import { defineStore } from 'pinia'
import { useWebSocket } from '@vueuse/core'
import { useUserStore } from './user'
import { ref, watch } from 'vue'

let lastUid = ref('')
let ws: ReturnType<typeof useWebSocket> | null = null

export const useWebSocketStore = defineStore('websocket', () => {
  const userStore = useUserStore()
  const status = ref('CLOSED')
  const data = ref<any>(null)

  // 启动 WebSocket 连接
  const connect = () => {
    if (!userStore.getToken || userStore.getToken === '') {
      console.log('WebSocket: 无 token，跳过连接')
      return
    }

    // 如果已经连接，先关闭
    if (ws) {
      ws.close()
    }

    const wsUrl = `${import.meta.env.VITE_WEB_SOCKET_API}/infra/ws?token=${
      userStore.getToken
    }`
    console.log('WebSocket 连接启动', wsUrl)

    ws = useWebSocket(wsUrl, {
      heartbeat: {
        interval: 5000, // 心跳间隔（毫秒，默认 5 秒）
      },
      autoReconnect: {
        retries: 3, // 重连次数，-1 表示无限重连
        delay: 30000, // 重连延迟时间（毫秒）
        onFailed: () => {
          console.error('WebSocket 重连失败')
        },
      },
      immediate: true,
    })

    // 持续同步 ws 实例的状态和数据到本地 ref
    watch(
      () => ws?.status.value,
      newStatus => {
        if (newStatus) {
          status.value = newStatus
        }
      },
      { immediate: true }
    )

    watch(
      () => ws?.data.value,
      newData => {
        console.log('WebSocket 收到数据:', newData)

        // 过滤重复消息
        if (newData?.content && newData.content != '') {
          try {
            let str = JSON.parse(newData.content)
            if (str.uid == lastUid.value) {
              console.log('WebSocket Store 重复消息', newData)
              return
            }
            lastUid.value = str.uid
          } catch (error) {
            // 如果解析失败，继续处理
          }
        }

        data.value = newData
      },
      { immediate: true }
    )

    return ws
  }

  // 断开 WebSocket 连接
  const disconnect = () => {
    if (ws) {
      console.log('WebSocket 连接断开')
      ws.close()
      ws = null
      status.value = 'CLOSED'
      data.value = null
    }
  }

  // 发送消息
  const send = (message: any) => {
    if (ws) {
      ws.send(message)
    } else {
      console.warn('WebSocket 未连接，无法发送消息')
    }
  }

  // 获取当前 WebSocket 实例
  const getInstance = () => ws

  return {
    status,
    data,
    send,
    connect,
    disconnect,
    getInstance,
  }
})
